<!-- eslint-disable max-len -->
<template>
  <div>
    <LoadingSpinner v-if="loading" />
    <div v-if="!loading" class="block relative w-full mt-2">
      <div class="block relative px-4">
        <div class="title-block block relative mb-6">
          <h2
            class="
              title-block
              block
              text-lg
              font-bold
              m-0
              text-darkblack text-center
            "
          >
            {{ $t("pages.faq.help_Center") }}
          </h2>
        </div>
        <h2
          v-if="list.length > 0"
          class="
            Subtitle-block
            block
            text-md
            font-bold
            mb-2.5
            text-darkblack text-left
            uppercase
          "
        >
          FAQ
        </h2>

        <div
          v-if="list.length > 0"
          class="relative block accordian-list-block mb-9"
        >
          <div
            v-for="(val, idx) in list"
            :key="`faq_${idx}`"
            class="block relative walter-block bg-white rounded-lg mb-4 tab"
          >
            <div class="card tab">
              <input
                :id="`tab-single_${idx}`"
                class="card-heading absolute opacity-0"
                type="checkbox"
                :name="`tabs_${idx}`"
              />
              <label
                class="
                  card-heading
                  cursor-pointer
                  flex
                  align-center
                  justify-between
                  tab
                  w-full
                  rounded-t-lg
                  border-b
                  solid
                  border-agray1
                "
                :for="`tab-single_${idx}`"
              >
                <span class="block relative text-md font-bold text-darkblack">
                  {{ val.title }}
                </span>
                <span class="flex transform rotate-180 duration-500">
                  <svg
                    class="w-3.5 h-3.5"
                    viewBox="0 0 14 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.1294 6.60857C13.1294 6.69564 13.1034 6.78073 13.0547 6.85294C13.0061 6.92515 12.937 6.9812 12.8563 7.01393C12.7756 7.04665 12.687 7.05456 12.6018 7.03665C12.5166 7.01873 12.4387 6.9758 12.378 6.91334L6.99984 1.53517L1.62166 6.91334C1.58135 6.95533 1.53306 6.98885 1.47963 7.01195C1.4262 7.03504 1.3687 7.04724 1.3105 7.04783C1.25229 7.04842 1.19455 7.03739 1.14066 7.01539C1.08677 6.99339 1.03782 6.96086 0.996657 6.9197C0.955498 6.87854 0.922966 6.82958 0.900964 6.77569C0.878963 6.7218 0.867935 6.66406 0.868527 6.60586C0.869119 6.54766 0.881317 6.49015 0.90441 6.43672C0.927502 6.38329 0.961024 6.33501 1.00301 6.29469L6.69051 0.60719C6.77256 0.525174 6.88382 0.479101 6.99984 0.479101C7.11585 0.479101 7.22711 0.525174 7.30916 0.60719L12.9967 6.29469C13.0387 6.33547 13.072 6.38426 13.0948 6.43818C13.1176 6.49209 13.1294 6.55004 13.1294 6.60857V6.60857Z"
                      fill="#333333"
                    />
                  </svg>
                </span>
              </label>
              <div class="tab-content overflow-hidden card-body">
                <div class="block relative pl-0 pr-0 pt-2 pb-1">
                  <p
                    class="
                      block
                      relative
                      mb-1.5
                      text-sm
                      font-normal
                      text-darkgray1
                    "
                  >
                    {{ val.content }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group block relative mb-3.5">
          <label class="retlative block text-md font-bold text-darkgray mb-1">
            {{ $t("pages.faq.request_moreinfo") }}
          </label>
          <p class="retlative block text-sm font-normal text-darkgray">
            {{ $t("pages.faq.request_moreinfo_detail") }}
          </p>
        </div>

        <div class="form-group block relative mb-4">
          <label class="retlative block text-sm font-bold text-darkgray mb-1">
            {{ $t("pages.faq.more_info") }}
          </label>
          <textarea
            v-model="comment"
            class="
              border
              solid
              h-24
              w-full
              relative
              font-medium
              px-4
              pt-3
              pb-3
              rounded-lg
              border-color
              placeholder-gray
              text-sm
              outline-none
              resize-none
            "
            :placeholder="$t('pages.common.buttons.dis50')"
          ></textarea>
        </div>

        <!-- Button block -->
        <div
          class="
            button-block
            block
            mb-0
            current_action
            fixed
            left-0
            bottom-0
            w-full
            px-4
            bg-white
          "
        >
          <div class="form-group block relative mb-0 pt-4 pb-4">
            <button
              class="
                w-full
                flex
                items-center
                justify-center
                btn_apply
                rounded-lg
                text-white
                btn_action
              "
              :class="{
                'disabled:opacity-50': comment.length === 0,
              }"
              :disabled="comment.length === 0"
              @click="save"
            >
              {{ $t("pages.faq.request_information_button_text") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner";
export default {
  name: "FAQ",
  components: { LoadingSpinner },
  data() {
    return {
      comment: "",
    };
  },
  computed: {
    list() {
      return this.$store.getters["info/faq"];
    },
  },
  created() {
    this.loading = true;
    this.$store.dispatch("info/fetchFaq").then(() => {
      this.loading = false;
    });
  },
  methods: {
    save() {
      this.loading = true;
      this.$store
        .dispatch("info/requestMoreInfo", {
          comment: this.comment,
        })
        .then(() => {
          this.loading = false;
          this.comment = "";
          this.$store.commit("app/showNotification", {
            heading: this.$t("pages.common.buttons.dis30"),
            desc: this.$t("pages.common.buttons.dis31"),
            buttons: {
              okay: {
                text: this.$t("pages.common.buttons.dis32"),
                action: () => {
                  this.$router.push({ name: "offerSearch" });
                },
              },
            },
            icon: {
              show: true,
              type: "success",
            },
          });
        });
    },
  },
};
</script>

<style scoped>
.tab-content {
  max-height: 0;
  -webkit-transition: max-height 0.35s;
  -o-transition: max-height 0.35s;
  transition: max-height 0.35s;
}

.tab input:checked ~ .tab-content {
  max-height: unset;
}
.tab input:checked + label span.flex.transform.rotate-0 {
  transform: rotate(0deg) !important;
}

.tab input[type="radio"]:checked + label .iconbox {
  transform: rotate(180deg);
}
.tab input:checked + label .rotate-0 {
  -webkit-transform: rotate(0deg) !important;
  transform: rotate(0deg) !important;
}
.tab input:checked + label {
  display: flex;
  background: #63b15b;
}
.tab input:checked ~ .tab-content {
  box-shadow: none;
}
.tab input:checked + label span {
  color: white;
}
</style>
